// Maps Google OAuth scopes to the user-facing capability they unlock.
// Note: `drive.file` is intentionally NOT mapped here — it is a general
// per-file Drive scope, not Meet-specific. Surfacing "Meet" when only
// drive.file is missing would be misleading; the generic "Limited Google
// permissions" banner is more accurate in that case.
export const SCOPE_CAPABILITIES: Record<string, string> = {
  'https://www.googleapis.com/auth/gmail.readonly': 'Gmail',
  'https://www.googleapis.com/auth/gmail.send': 'Gmail',
  'https://www.googleapis.com/auth/calendar': 'Calendar',
  'https://www.googleapis.com/auth/calendar.readonly': 'Calendar',
  'https://www.googleapis.com/auth/meetings.space.readonly': 'Meet',
  'https://www.googleapis.com/auth/drive.meet.readonly': 'Meet',
};

export function getUnavailableCapabilities(
  missingScopes: string[]
): Set<string> {
  const out = new Set<string>();
  for (const scope of missingScopes) {
    const capability = SCOPE_CAPABILITIES[scope];
    if (capability) {
      out.add(capability);
    }
  }
  return out;
}
